export default __webpack_public_path__ + "static/media/career.60ab74b7.jpg";